export default "__VITE_ASSET__D0RC2jah__"